import React, {useRef, useState} from 'react';
import {IconExclamationCircle, IconID, IconPhoto, IconSettings, IconShieldCheck} from "../../../../components/icons";
import {Dossier} from "../../../../components/models";
import {PhotoCarousel} from './components/PhotoCarousel';

const FicheForm = ({dossier = null, formatEtatChoc}: { dossier?: Dossier | null, formatEtatChoc: any }) => {
  const fileInputRef = useRef(null)
  const vehicule = dossier?.vehicule
  const [vehicleData, setVehicleData] = useState({
    annee: vehicule?.annee,
    autoRadio: vehicule?.autoRadio,
    boiteVitesse: vehicule?.boiteVitesse,
    broyeLe: vehicule?.broyeLe,
    broyeur: vehicule?.broyeur,
    carrosserie: vehicule?.carrosserie,
    choc: vehicule?.choc,
    cle: vehicule?.cle,
    codeAntiDemarrage: vehicule?.codeAntiDemarrage,
    codeCouleur: vehicule?.codeCouleur,
    couleur: vehicule?.couleur,
    cvDin: vehicule?.cvDin,
    cylindree: vehicule?.cylindree,
    dateExpertise: vehicule?.dateExpertise,
    depollueLe: vehicule?.depollueLe,
    depolluePar: vehicule?.depolluePar,
    energie: vehicule?.energie,
    etat: vehicule?.etat,
    ficheType: vehicule?.ficheType,
    genre: vehicule?.genre,
    genreLibelle: vehicule?.genreLibelle,
    groupe: vehicule?.groupe,
    id: vehicule?.id,
    immatriculation: vehicule?.immatriculation,
    kType: vehicule?.kType,
    kilometrage: vehicule?.kilometrage,
    lot: vehicule?.lot,
    marque: vehicule?.marque,
    modele: vehicule?.modele,
    numMoteur: vehicule?.numMoteur,
    placesAssises: vehicule?.placesAssises,
    platineLe: vehicule?.platineLe,
    platinePar: vehicule?.platinePar,
    poidsVide: vehicule?.poidsVide,
    portes: vehicule?.portes,
    premiereMiseEnCirculation: vehicule?.premiereMiseEnCirculation,
    typeBD: vehicule?.typeBd,
    typeKilometrage: vehicule?.typeKilometrage,
    typeMoteur: vehicule?.typeMoteur,
    typeVin: vehicule?.typeVin,
    vinDocument: vehicule?.vinDocument,
    photoVehicule: {
      avant: null,
      arriere: null,
      coteG: null,
      coteD: null,
    }
  })
  const [photos, setPhotos] = useState(() => buildPhotoUrls(vehicule?.immatriculation))

  const handleChange = (e) => {
    const value = e.target.dataset.value
    const name = e.target.name

    setVehicleData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // Génération des photos jusqu'à 30
  function buildPhotoUrls(immat: string, max = 30): string[] {
    const firstLetter = immat[0].toUpperCase()
    return Array.from({length: max}, (_, i) =>
      `https://d1zsawkzupb9kl.cloudfront.net/Photos${firstLetter}/${immat}_${i + 1}.jpg`
    )
  }

  // Suppression des urls non fonctionnels
  const handleError = (badUrl: string) => {
    setPhotos(prev => {
      const index = prev.indexOf(badUrl)
      return index === -1 ? prev : prev.slice(0, index)
    })
  }

  // const handlePhotoChange = (e, section) => {
  //   const file = e.target.files[0]
  //   setVehicleData(prev => ({
  //     ...prev,
  //     photos: {
  //       ...prev.photoVehicule,
  //       [section]: file,
  //     },
  //   }))
  // }

  // const handleSubmit = async (e) => {
  //     e.preventDefault()
  //
  //     const formData = new FormData()
  //
  //     Object.entries(vehicleData.photoVehicule).forEach(([section, file]) => {
  //         if (file) {
  //             formData.append(section, file)
  //         }
  //     })
  //
  //     const response = await fetch('/api/vehicule/', {
  //         method: 'POST',
  //         body: formData,
  //     })
  //
  //     const data = await response.json()
  // }

  // const handleDivClick = (section) => {
  //   setCurrentSection(section)
  //   fileInputRef.current.click()
  // }
  //
  // // fichier sélectionné
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0]
  //   if (!file || !currentSection) return
  //
  //   setVehicleData((prev) => ({
  //     ...prev,
  //     photoVehicule: {
  //       ...prev.photoVehicule,
  //       [currentSection!]: file,
  //     },
  //   }))
  //
  //   e.target.value = ""
  // }

  return (
    <div className="space-y-4">
      {/* Photos */}
      <div className="section-card">
        <div className="section-header">
          <div className="section-icon bg-indigo-100 text-indigo-600">
            <IconPhoto className="w-3.5 h-3.5"/>
          </div>
          <span className="section-title">Photos du véhicule</span>
          {/*<button*/}
          {/*  className="ml-auto text-xs text-green-600 hover:text-green-700 font-medium flex items-center gap-1">*/}
          {/*  <IconPlus className="w-3.5 h-3.5"/>*/}
          {/*  Ajouter*/}
          {/*</button>*/}
        </div>
        <div className="section-body">
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{display: "none"}}
            // onChange={handleFileChange}
          />

          <PhotoCarousel
            urls={photos}
            onImageError={handleError}
          />

        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Identification véhicule */}
        <div className="section-card">
          <div className="section-header">
            <div className="section-icon bg-blue-100 text-blue-600">
              <IconID className="w-3.5 h-3.5"/>
            </div>
            <span className="section-title">Identification</span>
          </div>
          <div className="section-body grid grid-cols-2 gap-3">
            <div>
              <label className="form-label">Genre</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  className="form-input-w-none w-20 hover:cursor-not-allowed"
                  name='genre'
                  value={vehicleData?.genre}
                  onChange={handleChange}
                  disabled
                  readOnly
                />
                <input
                  type="text"
                  className="form-input flex-1 hover:cursor-not-allowed"
                  placeholder="Détail"
                  name='genreLibelle'
                  value={vehicleData?.genreLibelle}
                  onChange={handleChange}
                  disabled
                  readOnly
                />
              </div>
            </div>
            <div>
              <label className="form-label">Année</label>
              <input
                type="text"
                className="form-input hover:cursor-not-allowed"
                name='annee'
                value={vehicleData?.premiereMiseEnCirculation?.split('T')[0].split('-')[0]}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            <div>
              <label className="form-label">Marque</label>
              <select
                className="form-input form-select hover:cursor-not-allowed"
                disabled={true}>
                <option>{vehicleData?.marque}</option>
              </select>
            </div>
            <div>
              <label className="form-label">Modèle</label>
              <input
                type="text"
                className="form-input hover:cursor-not-allowed"
                value={vehicleData?.modele}
                disabled
              />
            </div>
            <div>
              <label className="form-label">VIN sur document</label>
              <input
                type="text"
                className="form-input font-mono uppercase hover:cursor-not-allowed"
                placeholder="VIN"
                name='vinDocument'
                value={vehicleData?.vinDocument}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            {/*<div>*/}
            {/*  <label className="form-label">Type VIN</label>*/}
            {/*  <input*/}
            {/*      type="text"*/}
            {/*      className="form-input hover:cursor-not-allowed"*/}
            {/*      placeholder="VIN type"*/}
            {/*      name='typeVin'*/}
            {/*      value={vehicleData?.typeVin}*/}
            {/*      onChange={handleChange}*/}
            {/*      disabled*/}
            {/*      readOnly*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>

        {/* Caractéristiques techniques */}
        <div className="section-card">
          <div className="section-header">
            <div className="section-icon bg-green-100 text-green-600">
              <IconSettings className="w-3.5 h-3.5"/>
            </div>
            <span className="section-title">Caractéristiques</span>
          </div>
          <div className="section-body grid grid-cols-2 gap-3">
            <div>
              <label className="form-label">Couleur</label>
              <select
                className="form-input form-select hover:cursor-not-allowed"
                value={vehicleData?.couleur}
                name='couleur'
                onChange={handleChange}
                disabled
              >
                <option value='Noir'>Noir</option>
                <option value='Blanc'>Blanc</option>
                <option value='Gris'>Gris</option>
              </select>
            </div>
            <div>
              <label className="form-label">Énergie</label>
              <select
                className="form-input form-select hover:cursor-not-allowed"
                value={vehicleData?.energie}
                name='energie'
                onChange={handleChange}
                disabled
              >
                <option value='Essence'>Essence</option>
                <option value='Diesel'>Diesel</option>
                <option value='Hybride'>Hybride</option>
              </select>
            </div>
            <div>
              <label className="form-label">Cylindrée (cc)</label>
              <input
                type="text"
                className="form-input hover:cursor-not-allowed"
                placeholder="cc"
                name='cylindree'
                value={vehicleData?.cylindree}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            <div>
              <label className="form-label">CV DIN</label>
              <input
                type="text"
                className="form-input hover:cursor-not-allowed"
                placeholder="CV"
                name='cvDIN'
                value={vehicleData?.cvDin}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            <div>
              <label className="form-label">1ère mise en circulation</label>
              <input
                type="date"
                className="form-input hover:cursor-not-allowed"
                name='premierMiseEnCirculation'
                value={vehicleData?.premiereMiseEnCirculation?.split('T')[0]}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
          </div>
        </div>

        {/* État & Traitement */}
        <div className="section-card">
          <div className="section-header">
            <div className="section-icon bg-amber-100 text-amber-600">
              <IconShieldCheck className="w-3.5 h-3.5"/>
            </div>
            <span className="section-title">État & Traitement</span>
          </div>
          <div className="section-body grid grid-cols-2 gap-3">
            <div>
              <label className="form-label">Choc</label>
              <textarea
                className="form-input resize-none"
                rows={4}
                placeholder="Description du choc..."
                name='choc'
                value={formatEtatChoc(vehicleData?.choc, 'choc')}
                onChange={handleChange}
                disabled
                readOnly
              ></textarea>
            </div>
            <div>
              <label className="form-label">État</label>
              <textarea
                className="form-input resize-none"
                rows={4}
                placeholder="État général..."
                name='etat'
                value={formatEtatChoc(vehicleData?.etat, 'etat')}
                onChange={handleChange}
                disabled
                readOnly
              ></textarea>
            </div>
            {/*<div>*/}
            {/*  <label className="form-label">Dépollué le</label>*/}
            {/*  <input*/}
            {/*    type="date"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    name='depollueLe'*/}
            {/*    value={vehicleData?.depollueLe}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Par</label>*/}
            {/*  <select*/}
            {/*    className="form-input form-select hover:cursor-not-allowed"*/}
            {/*    name='depolluerPar'*/}
            {/*    value={vehicleData?.depolluePar}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*  >*/}
            {/*    <option>Sélectionner...</option>*/}
            {/*  </select>*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Platiné le</label>*/}
            {/*  <input*/}
            {/*    type="date"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    name='platineLe'*/}
            {/*    value={vehicleData?.platineLe}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Par</label>*/}
            {/*  <select*/}
            {/*    className="form-input form-select hover:cursor-not-allowed"*/}
            {/*    name='platinePar'*/}
            {/*    value={vehicleData?.platinePar}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*  >*/}
            {/*    <option>Sélectionner...</option>*/}
            {/*  </select>*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Broyeur</label>*/}
            {/*  <select*/}
            {/*    className="form-input form-select hover:cursor-not-allowed"*/}
            {/*    name='broyeur'*/}
            {/*    value={vehicleData?.broyeur}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*  >*/}
            {/*    <option>Sélectionner...</option>*/}
            {/*  </select>*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Le</label>*/}
            {/*  <input*/}
            {/*    type="date"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    name='broyeLe'*/}
            {/*    value={vehicleData?.broyeLe}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div className="col-span-2">*/}
            {/*  <label className="form-label">Lot</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="N° de lot"*/}
            {/*    name='lot'*/}
            {/*    value={vehicleData?.lot}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>

        {/* Infos complémentaires */}
        <div className="section-card">
          <div className="section-header">
            <div className="section-icon bg-purple-100 text-purple-600">
              <IconExclamationCircle className="w-3.5 h-3.5"/>
            </div>
            <span className="section-title">Infos complémentaires</span>
          </div>
          <div className="section-body grid grid-cols-2 gap-3">
            {/*<div>*/}
            {/*  <label className="form-label">Groupe</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="Groupe"*/}
            {/*    name='groupe'*/}
            {/*    value={vehicleData?.groupe}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Fiche type</label>*/}
            {/*  <select*/}
            {/*    className="form-input form-select hover:cursor-not-allowed"*/}
            {/*    name='ficheType'*/}
            {/*    value={vehicleData?.ficheType}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*  >*/}
            {/*    <option>Sélectionner...</option>*/}
            {/*  </select>*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">K_Type</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="K_Type"*/}
            {/*    name='kType'*/}
            {/*    value={vehicleData?.kType}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Code couleur</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="Code"*/}
            {/*    name='codeCouleur'*/}
            {/*    value={vehicleData?.codeCouleur}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Date expertise</label>*/}
            {/*  <input*/}
            {/*    type="date"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    name='dateExpertise'*/}
            {/*    value={vehicleData?.dateExpertise}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*  <label className="form-label">Type moteur</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="Type"*/}
            {/*    name='typeMoteur'*/}
            {/*    value={vehicleData?.typeMoteur}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            <div>
              <label className="form-label">Km</label>
              <input
                type="number"
                className="form-input flex-1 hover:cursor-not-allowed"
                name='kilometrage'
                value={vehicleData?.kilometrage?.includes(" km") ? vehicleData?.kilometrage?.split(' ')[0] : vehicleData?.kilometrage}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            {/*<div>*/}
            {/*  <label className="form-label">Type Kilométrage</label>*/}
            {/*  <div className="flex gap-2 items-center mt-4">*/}
            {/*    <label className="flex items-center gap-1 text-xs">*/}
            {/*      <input*/}
            {/*        type="radio"*/}
            {/*        name="typeKilometrage"*/}
            {/*        className="w-3 h-3 hover:cursor-not-allowed"*/}
            {/*        data-value="Compteur"*/}
            {/*        checked={vehicleData?.typeKilometrage === 'Compteur'}*/}
            {/*        onChange={handleChange}*/}
            {/*        disabled*/}
            {/*        readOnly*/}
            {/*      /> Compteur*/}
            {/*    </label>*/}
            {/*    <label className="flex items-center gap-1 text-xs">*/}
            {/*      <input*/}
            {/*        type="radio"*/}
            {/*        name="typeKilometrage"*/}
            {/*        className="w-3 h-3 hover:cursor-not-allowed"*/}
            {/*        data-value="Compteur"*/}
            {/*        checked={vehicleData?.typeKilometrage === 'Garantis'}*/}
            {/*        onChange={handleChange}*/}
            {/*        disabled*/}
            {/*        readOnly*/}
            {/*      /> Garantis*/}
            {/*    </label>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div>
              <label className="form-label">Clé</label>
              <input
                type="text"
                className="form-input hover:cursor-not-allowed"
                placeholder="Clé"
                name='cle'
                value={vehicleData?.cle}
                onChange={handleChange}
                disabled
                readOnly
              />
            </div>
            {/*<div>*/}
            {/*  <label className="form-label">Code anti-démarrage</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="Code"*/}
            {/*    name='codeAntiDemarrage'*/}
            {/*    value={vehicleData?.codeAntiDemarrage}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div className="col-span-2">*/}
            {/*  <label className="form-label">Auto-radio</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-input hover:cursor-not-allowed"*/}
            {/*    placeholder="Modèle auto-radio"*/}
            {/*    name='autoRadio'*/}
            {/*    value={vehicleData?.autoRadio}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled*/}
            {/*    readOnly*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FicheForm;